import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'pine', d: 'M-2,-1h1v1.5h-1zM1,-1h1v1.5h-1z' },
    {
      paint: 'frog',
      d: 'M-1,-2.5h2v1h-2zM-1,-1.5h0.5v1h-0.5zM0.5,-1.5h0.5v1h-0.5zM-1,-0.5h2v1h-2zM-1,0.5h0.5v0.5h-0.5zM0.5,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'leafLight', d: 'M-0.5,-1.5h1v1h-1z' },
  ],
  pixels: 38,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
